<div class="container-fluid">

  <h4 id="upper">TEP/PROJETS</h4>
  <div class="d-flex flex-column align-items-end">

    <div class="d-flex mb-2">
      <div class="me-3">
        <label class="d-inline-flex align-items-center">
          Début:
          <input disabled type="date" class="form-control form-control-sm ms-2" [(ngModel)]="dateDebut"
            name="dateDebut">
        </label>
      </div>
      <div>
        <label class="d-inline-flex align-items-center">
          Fin:
          <input type="date" class="form-control form-control-sm ms-2" [(ngModel)]="dateFin" name="dateFin">
        </label>
      </div>
    </div>

    <div class="d-flex align-items-center mb-4">
      <div class="me-2">
        <label class="d-inline-flex align-items-center mb-0">
          Programme:
          <select name="selectedProjet" class="form-select form-select-sm ms-2" [(ngModel)]="selectedProjet"
            style="min-width: 200px;">
            <option [value]="'DEFAULT'">Sélectionner un programme</option>
            <option *ngFor="let item of projetItems" [value]="item?.reference">
              {{ item?.libelle }}
            </option>
          </select>
        </label>
      </div>

      <div class="me-2">
        <button (click)="getStatistiqueProjetsByProgramme()" type="button"
          class="btn btn-primary btn-sm d-flex align-items-center">
          <i class="pi pi-search me-1" style="font-size: 0.8rem"></i> Rechercher
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" ngbDropdownToggle
          class="btn btn-secondary btn-sm dropdown-toggle d-flex align-items-center" id="dropdownMenuButton">
          Exporter <i class="pi pi-upload ms-1" style="font-size: 0.8rem"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" (click)="exportToDocument('pdf')">Au format PDF</a>
          <a class="dropdown-item" (click)="exportToDocument('excel')">Au format Excel</a>
        </div>
      </div>
    </div>

  </div>


  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">

          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive mt-3">
                <table class="table table-centered datatable dt-responsive nowrap"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                  <thead class="thead-light rwd-table">
                    <tr>
                      <th>Code </th>
                      <th>Programme/Action/Activité</th>
                      <th>Poids </th>
                      <th>TEP Prévu</th>
                      <th>TEP Réalisé</th>
                      <th>Écart</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of paginatedProjets; let index = index">
                      <td>{{ item.action.code }}</td>
                      <td>{{ item.action.libelle }}</td>
                      <td>{{ item.action.poids_action }}</td>

                      <td>{{ item.tep_prevu }}</td>
                      <td>{{ item.tep_realise }}</td>
                      <td>{{ (item.tep_realise - item.tep_prevu) | number:'1.2-2' }}</td>
                      <td>
                        <button class="btn btn-success btn-sm" (click)="detailsProjet(item)">
                          Détails
                        </button>
                      </td>
                    </tr>

                    <tr *ngIf="projetData.length === 0 && isLoading === false">
                      <td colspan="6" class="text-center">
                        <h5 id="graycolor">Aucune donnée trouvée</h5>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                <div class="container">
                  <div class="row">
                    <div class="text-center">
                      <h5 id="graycolor">Chargement en cours</h5>
                      <div class="loader4"></div>
                    </div>
                  </div>
                </div>
              </div>
              <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
                [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
              </p-paginator>
            </div>

            <!-- <div class="col-lg-4">
              <div class="mt-3">
                <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
              </div>
            </div> -->
          </div>

        </div>
      </div>
    </div>
  </div>


</div>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>